(() => {
  const root = document.documentElement;
  root.classList.add('nx-content-protected');

  const isEditable = (target) => {
    if (!(target instanceof Element)) return false;
    return Boolean(target.closest('input, textarea, select, option, [contenteditable="true"], [contenteditable="plaintext-only"]'));
  };

  document.addEventListener('dragstart', (event) => {
    if (isEditable(event.target)) return;
    if (event.target instanceof Element && event.target.closest('img, picture, svg, video, canvas, a')) {
      event.preventDefault();
    }
  }, { capture: true });

  document.addEventListener('contextmenu', (event) => {
    if (isEditable(event.target)) return;
    if (event.target instanceof Element && event.target.closest('img, picture, svg, video, canvas')) {
      event.preventDefault();
    }
  }, { capture: true });

  document.addEventListener('selectstart', (event) => {
    if (!isEditable(event.target)) event.preventDefault();
  }, { capture: true });
})();
